import { isGetStartedInListViewEnabled } from './isGetStartedInListViewEnabled';
import { isGetStartedInListViewClosed } from './isGetStartedInListViewClosed';
import { getStore } from '../store/store';
import { getGetStartedPositionOverride } from '../utils/getGetStartedPositionOverride';

export function isGetStartedInQuickOptionVisible(): boolean {
    return (
        getStore().tasks &&
        (getGetStartedPositionOverride() === '1' ||
            (isGetStartedInListViewEnabled() && isGetStartedInListViewClosed()))
    );
}
